import type { ComponentProps } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';

import { cn } from '@poseidon/components/cn';

type DetailPageProps = ComponentProps<'div'> & {
  initiallyAnimate?: boolean;
  detailSize?: 'small';
};

export const DetailPage = ({ children, initiallyAnimate, detailSize }: DetailPageProps) => {
  const [wasOpenedInitially, setWasOpenedInitially] = useState(false);

  return (
    <AnimatePresence>
      <motion.div
        className={cn(
          'absolute bottom-0 right-0 top-0 flex h-full flex-col items-stretch z-50 border-l border-(--border-color) bg-white dark:bg-slate-900',
          'font-[family-name:var(--main-font)] text-(--header-text-color)',
          detailSize === 'small' ? 'w-[260px]' : 'w-(--detail-width)',
        )}
        initial={initiallyAnimate && !wasOpenedInitially ? undefined : { opacity: 0.2, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        onAnimationStart={() => {
          if (initiallyAnimate && !wasOpenedInitially) {
            setWasOpenedInitially(true);
          }
        }}
        transition={{ type: 'spring' }}>
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
